import { logDebugging } from '../../log/logger';
import { IMPRESSION_TYPE } from '../constants/TrackingConstants';

export function validateImpression(impressionType, eventReached) {
  if (impressionType === IMPRESSION_TYPE.IMPRESSION && !eventReached[IMPRESSION_TYPE.IMPRESSION]) {
    return true;
  }
  if (
    impressionType === IMPRESSION_TYPE.START &&
    eventReached[IMPRESSION_TYPE.IMPRESSION] &&
    !eventReached[IMPRESSION_TYPE.START]
  ) {
    return true;
  }
  if (
    impressionType === IMPRESSION_TYPE.FIRST_QUARTILE &&
    eventReached[IMPRESSION_TYPE.IMPRESSION] &&
    eventReached[IMPRESSION_TYPE.START] &&
    !eventReached[IMPRESSION_TYPE.FIRST_QUARTILE]
  ) {
    return true;
  }
  if (
    impressionType === IMPRESSION_TYPE.MIDPOINT &&
    eventReached[IMPRESSION_TYPE.IMPRESSION] &&
    eventReached[IMPRESSION_TYPE.START] &&
    eventReached[IMPRESSION_TYPE.FIRST_QUARTILE] &&
    !eventReached[IMPRESSION_TYPE.MIDPOINT]
  ) {
    return true;
  }
  if (
    impressionType === IMPRESSION_TYPE.THIRD_QUARTILE &&
    eventReached[IMPRESSION_TYPE.IMPRESSION] &&
    eventReached[IMPRESSION_TYPE.START] &&
    eventReached[IMPRESSION_TYPE.FIRST_QUARTILE] &&
    eventReached[IMPRESSION_TYPE.MIDPOINT] &&
    !eventReached[IMPRESSION_TYPE.THIRD_QUARTILE]
  ) {
    return true;
  }
  if (
    impressionType === IMPRESSION_TYPE.COMPLETE &&
    eventReached[IMPRESSION_TYPE.IMPRESSION] &&
    eventReached[IMPRESSION_TYPE.START] &&
    eventReached[IMPRESSION_TYPE.FIRST_QUARTILE] &&
    eventReached[IMPRESSION_TYPE.MIDPOINT] &&
    eventReached[IMPRESSION_TYPE.THIRD_QUARTILE] &&
    !this.eventReached[IMPRESSION_TYPE.COMPLETE]
  ) {
    return true;
  }
  if (
    impressionType === IMPRESSION_TYPE.DISPLAY_PRE ||
    impressionType === IMPRESSION_TYPE.DISPLAY_POST ||
    impressionType === IMPRESSION_TYPE.CLICK
  ) {
    return true;
  }

  return false;
}

export function checkImpression(impressionType, eventReached) {
  if (impressionType && eventReached[impressionType]) {
    return false;
  }
  if (impressionType && !validateImpression(impressionType)) {
    logDebugging(`EVENTO ${impressionType} NO VALIDO `);
  }

  if (impressionType !== IMPRESSION_TYPE.CLICK) {
    this.eventReached[impressionType] = true;
  }
  return true;
}
